import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { SwapPairsTitleContainer, SwapPairTitle, Text } from './styles';
export const SwapPairsTitleLoader = () => {
    const { colors } = useTheme();
    return (_jsx(SwapPairsTitleContainer, { children: _jsx(SwapPairTitle, { backgroundColor: colors.surface.interactiveDefault, foregroundColor: colors.surface.pressed, children: _jsx(Text, {}) }) }));
};
//# sourceMappingURL=SwapPairsTitleLoader.js.map